import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cx } from "./cx";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, "aria-invalid": ariaInvalid, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cx("nv-field", "nv-field--textarea", invalid && "nv-field--invalid", className)}
      aria-invalid={ariaInvalid ?? invalid ?? undefined}
      {...rest}
    />
  );
});
